export default __webpack_public_path__ + "static/media/Lola.99a0cf2b.png";